export function getPublicImageUrl(value) {
  const image = String(value || '').trim();
  if (!image || image.startsWith('data:') || image.startsWith('/')) return image;

  // Reuse the current origin for old uploaded URLs after a domain migration.
  if (typeof window !== 'undefined') {
    try {
      const parsed = new URL(image, window.location.origin);
      if (parsed.pathname.startsWith('/uploads/')) {
        return `${window.location.origin}${parsed.pathname}${parsed.search}`;
      }
    } catch (_) {
      return image;
    }
  }

  return image;
}
